import { ApplicationRef, EmbeddedViewRef, EnvironmentInjector, Injectable, createComponent, inject } from '@angular/core';
import { Arrays } from 'src/modules/utils/shared/arrays';
import { SmFileUploadInternalComponent } from '../components/sm-file-upload-internal/sm-file-upload-internal.component';
import { BrowserUploadedFile } from '../models/uploaded-file.model';
import { MessageDialogService } from './message-dialog.service';

@Injectable()
export class FileUploadService {
    //Nicht möglich über MainAppService wegen Circular Dependency
    messageDialog = inject(MessageDialogService);
    appRef = inject(ApplicationRef);
    environmentInjector = inject(EnvironmentInjector);

    async chooseFile(loadContents = true, acceptExtensions?: string[], maxFileSizeBytes?: number): Promise<BrowserUploadedFile[]> {
        const componentRef = createComponent(SmFileUploadInternalComponent, {
            environmentInjector: this.environmentInjector,
        });

        componentRef.instance.loadContents = loadContents;
        componentRef.instance.acceptExtensions = acceptExtensions;
        let prom = new Promise<BrowserUploadedFile[]>((resolve, _) => {
            componentRef.instance.onFilesAdded.subscribe(files => {
                this.appRef.detachView(componentRef.hostView);
                componentRef.destroy();
                resolve(files);
            });
        });

        this.appRef.attachView(componentRef.hostView);

        const domElem = (componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;

        document.body.appendChild(domElem);

        //Damit ChangeDetection die oben gesetzten Parameter auf das HTML anwendet
        //await Utils.sleep(100);

        (domElem.children[0] as any).click();

        let files = await prom;
        for (let file of files) {
            const size = loadContents ? file.contents.byteLength : file.legacy.size;
            if (size == 0) {
                await this.messageDialog.info("Die Datei '" + file.legacy.name + "' ist leer (0 Byte groß). Das Hochladen ist nicht möglich", 'Fehler');
                return [];
            }
            if (maxFileSizeBytes != null && size > maxFileSizeBytes) {
                await this.messageDialog.info("Die Datei '" + file.legacy.name + "' ist größer als die erlaubten " + maxFileSizeBytes + " Bytes. Das Hochladen ist nicht möglich", "Fehler");
                return [];
            }
        }

        if (acceptExtensions != null) {
            let invalid = files.filter(file => !acceptExtensions.some(ext => file.legacy.name.toLowerCase().endsWith(ext.toLowerCase())));
            if (invalid.length > 0) {
                await this.messageDialog.info(
                    'Die Datei' +
                        (invalid.length > 1 ? 'en ' : ' ') +
                        Arrays.itemsToString(invalid, ', ', file => file.legacy.name, ' und ') +
                        (invalid.length > 1 ? ' können' : ' kann') +
                        ' nicht geöffnet werden, da nur die Dateierweiterungen ' +
                        Arrays.itemsToString(acceptExtensions, ', ', null, ' und ') +
                        ' erlaubt sind'
                );
                return files.filter(file => acceptExtensions.some(ext => file.legacy.name.toLowerCase().endsWith(ext.toLowerCase())));
            }
        }

        return files;
    }
}
